module.exports = __webpack_public_path__ + "img/token.9db224d7.svg";